export default __webpack_public_path__ + "static/media/logo-white.c3033e08.png";